import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, IconButton, Typography } from '@material-ui/core';

const SchematicDrawerHeader = ({ classes, title, closeDrawer }) => {
  return (
    <Grid className={classes} container alignItems="center">
      <Grid item xs={11}>
        <Typography variant="h6" noWrap>
          {title}
        </Typography>
      </Grid>
      <Grid container item xs={1} justifyContent="flex-end">
        <IconButton title="Close" onClick={closeDrawer}>
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};
export default SchematicDrawerHeader;
